import { ElementRef } from '@angular/core';
import { HelpModalComponent } from './help-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "./help-modal.component";
const _c0 = ["helpModal"];
/**
 *
 * Help Modal Component Wrapped with Trigger
 *
 */
export class HelpModalWithTriggerComponent {
    constructor(eltRef) {
        this.eltRef = eltRef;
        this.modalName = this.eltRef.nativeElement.getAttribute('modalName');
        this.triggerLabel = this.eltRef.nativeElement.getAttribute('triggerLabel');
    }
    open() {
        this.helpModal.openModal(this.modalName);
    }
}
HelpModalWithTriggerComponent.ɵfac = function HelpModalWithTriggerComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HelpModalWithTriggerComponent)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
HelpModalWithTriggerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HelpModalWithTriggerComponent, selectors: [["ycn-help-modal-with-trigger"]], viewQuery: function HelpModalWithTriggerComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.helpModal = _t.first);
    } }, standalone: false, decls: 4, vars: 1, consts: [["helpModal", ""], [1, "help-toggler", 3, "click"]], template: function HelpModalWithTriggerComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "span", 1);
        i0.ɵɵlistener("click", function HelpModalWithTriggerComponent_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r1); const helpModal_r2 = i0.ɵɵreference(3); return i0.ɵɵresetView(helpModal_r2.openModal(ctx.modalName)); });
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(2, "ycn-help-modal", null, 0);
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵtextInterpolate(ctx.triggerLabel);
    } }, dependencies: [i1.HelpModalComponent], encapsulation: 2 });
